import {
  STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_BEGIN:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_SUCCESS:


      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
        }
      }
    case STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_FAILURE:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          error: action.data
        }
      }
    default:
      return state
  }
}
